module.exports = __webpack_public_path__ + "static/media/Snowing-flower.f5fa83b0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Snowing-flower.mp4
// module id = 103
// module chunks = 0